<script>
export default {
  name: "SessionLiveHeader",
  props:
      {
        session: {
          type: Object,
          required: true
        },
      },

  setup(props) {
    function sessionLeadLink(session) {
      if (session.participants?.length) {
        const lead = session.participants[0];
        if (lead?.member?.id) {
          return '/person/' + lead?.member?.id;
        }
      }
      return '#';
    }
    function sessionLeadImage(session) {
      if (session.participants?.length) {
        const lead = session.participants[0];
        if (lead?.member?.avatar_path) {
          return lead?.member?.avatar_path;
        }
      }
      return '/img/user-astronaut-square.png';
    }

    function participantName(p) {
      if (p.member) {
        return p.member.name;
      }
      if (p.member?.user) {
        return p.member.user.name;
      }
    }

    function participantCountGreater(session, lim) {
      const count = session.participants ? session.participants.length : 0;

      return count > lim;

    }

    return {
      sessionLeadLink,
      sessionLeadImage,
      participantName,
      participantCountGreater
    }
  },
}
</script>

<template>
  <header>
    <div class="flex items-center">
      <a :href="sessionLeadLink(session)" class="mr-2 flex-none hidden md:block">
        <img class="mx-auto h-12 w-12 rounded-full border-4 border-white border-opacity-25"
             :src="sessionLeadImage(session)" alt="Lead Presenter"
        >
      </a>
      <div>
        <h4 class="text-xs font-bold uppercase text-white text-opacity-75">
          <template v-for="(p,index) in session.participants" :key="p.id">
            <span v-show="index > 0" class="_delim text-black"> / </span>
            <a class="inherits-color link md:inline" :class="{'hidden': (index >= 2)}"
               :href="'/person/'+p.member?.id">
              {{ participantName(p) }}
            </a>
          </template>
          <span class="md:hidden" v-show="participantCountGreater(session, 2)"> and others</span></h4>
        <h1 class="header-gradient font-normal leading-tight text-xl md:text-2xl  widescreen:text-3x">
          <a :href="'/session/' + session.id">{{ session.title }}
          </a> <span
            class="text-sm">#{{ session.id }}</span></h1>
      </div>
    </div>
  </header>
</template>

<style scoped>

.delimiter {
  color: #ccc;
}

.pr {
  color: #666;
}

span.hide-last-delimiter:last-child span.delimiter {
  display: none;
}

.session-wrapping {
  background-color: rgba(0, 0, 0, 0.01);
  border: 1px solid rgba(0, 0, 0, 0.03);
}

.session-wrapping a {
  color: rgb(79, 70, 229);
}

.session-wrapping a.text-white {
  color: #FFF;
}

</style>

